import formOptions from "./formOptions.json";

export const taskStatusOptions = formOptions.taskStatusOptions || [];
export const projectStatusOptions = formOptions.projectStatusOptions || [];
export const roleOptions = formOptions.roleOptions || [];
export const operationalAreaOptions = formOptions.operationalAreaOptions || [];
export const businessOptions = formOptions.businessOptions || [];
export const labelOptions = formOptions.labelOptions || [];

export const interactionTypeOptions = formOptions.interactionTypeOptions || [];
export const interactionDirectionOptions = formOptions.interactionDirectionOptions || [];
export const valueActionOptions = formOptions.valueActionOptions || [];

export const contactStatusOptions = formOptions.contactStatusOptions || [];
export const contactSourceOptions = formOptions.contactSourceOptions || [];
export const preferredCommsMethodOptions = formOptions.preferredCommsMethodOptions || [];
export const engagementLevelOptions = formOptions.engagementLevelOptions || [];
export const fitScoreOptions = formOptions.fitScoreOptions || [];

export const taskStatusValues = taskStatusOptions.map((option) => option.value);
export const projectStatusValues = projectStatusOptions.map((option) => option.value);
export const roleValues = roleOptions.map((option) => option.value);
export const operationalAreaValues = operationalAreaOptions.map((option) => option.value);
export const businessValues = businessOptions.map((option) => option.value);
export const labelValues = labelOptions.map((option) => option.value);

export const interactionTypeValues = interactionTypeOptions.map((option) => option.value);
export const interactionDirectionValues = interactionDirectionOptions.map((option) => option.value);
export const valueActionValues = valueActionOptions.map((option) => option.value);

export const contactStatusValues = contactStatusOptions.map((option) => option.value);
export const contactSourceValues = contactSourceOptions.map((option) => option.value);
export const preferredCommsMethodValues = preferredCommsMethodOptions.map((option) => option.value);
export const engagementLevelValues = engagementLevelOptions.map((option) => option.value);
export const fitScoreValues = fitScoreOptions.map((option) => option.value);